import { NewJerseyPIPDocument } from '../../../src/components'

export default function NewJerseyPIPDocumentUpload() {
  return (
    <div className="cure-inner-container">
      <NewJerseyPIPDocument />
    </div>
  )
}
